/**
 * Extrae un mensaje legible de un error de API. Estaba duplicada byte-idéntica en 11 archivos
 * (Applications/Deploys/FeatureFlags/Images/Policies/Registries/Roles/Scopes/Servers/Teams/Users
 * Page) y faltaba por completo en otros ~10 cuyas mutaciones nunca mostraban el error real al
 * usuario (2026-09-23, mismo patrón que `invalidateEntity`: un helper, no N copias que divergen).
 */
export function getApiErrorMessage(error: unknown): string {
  if (error && typeof error === 'object') {
    const err = error as { error?: { message?: string }; message?: string };
    return err.error?.message || err.message || 'Unknown error';
  }
  return 'Unknown error';
}

/** Código de error del backend (p. ej. `DEPLOY_CONFLICT`, `SYNC_ALREADY_RUNNING`), si lo trae. */
export function getApiErrorCode(error: unknown): string | undefined {
  if (error && typeof error === 'object') {
    const err = error as { error?: { code?: string }; code?: string };
    return err.error?.code || err.code;
  }
  return undefined;
}
